module.exports = __webpack_public_path__ + "static/media/35.71d45cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/35.jpg
// module id = 210
// module chunks = 0